import { useCallback, useContext, useState } from 'react';

import { File as UploadedFile } from '../../../../../graphql/generated/graphql';
import { OnUploadProgress } from '../../../../../service/persistent/FileUploader';
import { context as DependencyContext } from '../../../../context/dependency';

export const useUploadAttachment = () => {
  const dependency = useContext(DependencyContext);

  const [uploading, setUploading] = useState(0);
  const [uploadedFile, setUploadedFile] = useState<UploadedFile>();
  const upload = useCallback(
    async (file: File | null, onUploadProgress?: OnUploadProgress) => {
      if (file == null) {
        setUploadedFile(undefined);
        return;
      }
      try {
        setUploading((uploading) => ++uploading);
        const fileType = 'image/'; // Currently allow only thumbnail image
        const fileTypeRegExp = /^image\/(png|jpeg|gif)/;
        if (!file.type.startsWith(fileType)) {
          throw new Error(`message.uploading_file_must_be_image`);
        } else if (!file.type.match(fileTypeRegExp)) {
          throw new Error(`message.file_format_not_confirm`);
        }

        const _uploadedFile: UploadedFile = await dependency.fileUploader.upload(file, onUploadProgress);
        setUploadedFile(_uploadedFile);
      } catch (err) {
        dependency.errorPresenter.showAsNonFatal(err);
      } finally {
        setUploading((uploading) => --uploading);
      }
    },
    [dependency],
  );

  return { upload, uploadedFile, uploading: uploading > 0 };
};
